import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const InformationIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path d="M8 17C8 16.4477 8.44772 16 9 16H11V12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10H12C12.5523 10 13 10.4477 13 11V16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z" />
      <path d="M13.25 7.25C13.25 6.55964 12.6904 6 12 6C11.3096 6 10.75 6.55964 10.75 7.25C10.75 7.94036 11.3096 8.5 12 8.5C12.6904 8.5 13.25 7.94036 13.25 7.25Z" />
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z" />
    </BaseIcon>
  );
};
